import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "play-20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { id: "Web/Filled/20\\xD720/play", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", strokeLinejoin: "round" },
        React.createElement("path", { id: "Path-2", stroke: "currentColor", strokeWidth: 2, fill: "currentColor", d: "M5 4v12l12-6z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
